const state = {
    rules: []
};

const mutations = {
    setRules(state, value) {
        state.rules = value;
    },
};

const actions = {
    updateRules({commit}, value) {
        commit('setRules', value);
    },
};

const getters = {
    rules: (state) => state.rules,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
